// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__XzThV","productName":"Table_productName__1wYBa"};